import { ActionType, createAction } from "typesafe-actions";

export const show = createAction("@components/userLocationRequest/show")<void>();
export const hide = createAction("@components/userLocationRequest/hide")<void>();
export const hideInSession = createAction("@components/userLocationRequest/hideInSession")<void>();

export type UserLocationRequestActions = ActionType<
  typeof hide | typeof hideInSession | typeof show
>;
